import { Tooltip, Typography, TypographyOwnProps } from '@mui/material';
import { TEXT_ELLIPSIS_LENGTH } from 'constants/ui/style';

type Props = Partial<{
  value: string;
  maxLength: number;
  textProps: TypographyOwnProps;
  enableTooltip: boolean;
}>;

const TextTooltip = (props: Props) => {
  const { value, maxLength = TEXT_ELLIPSIS_LENGTH, textProps, enableTooltip = true } = props;

  if (!value) {
    return <Typography>-</Typography>;
  }

  const isEllipsis = value?.length > maxLength;
  const displayedText = isEllipsis ? `${value.slice(0, maxLength)}...` : value;
  const isDisplayTooltip = enableTooltip && isEllipsis;

  return (
    <Tooltip title={isDisplayTooltip ? value : undefined}>
      <Typography {...textProps}>{displayedText}</Typography>
    </Tooltip>
  );
};

export default TextTooltip;
